export const localStorageKeys = {
  USER_SEARCH_PREFERENCES: 'userSearchPreferences',
  RECENT_METHODS: 'recentMethods',
  RECENT_SEARCHES: 'recentSearches',
  SELECTED_METHOD: 'selectedMethod',
  SHOW_COMMENTS: 'showComments',
};
